import { render, staticRenderFns } from "./QuickIcon.vue?vue&type=template&id=8d0e82a4&scoped=true&"
import script from "./QuickIcon.vue?vue&type=script&lang=js&"
export * from "./QuickIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuickIcon.vue?vue&type=style&index=0&id=8d0e82a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0e82a4",
  null
  
)

export default component.exports